import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpService } from 'src/app/services/http-service';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/Globals';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit, OnDestroy {

  private globals = Globals;
  httpSub$: Subscription = null;

  constructor(private httpService: HttpService, private router: Router, private toaster: ToastrService) { }

  ngOnInit() {
    // API registers logout as GET /merchant/logout (not PUT like login).
    this.httpSub$ = this.httpService.getRequest(this.globals.urls.authentication.logout)
      .subscribe(
        res => {
          this.clearLocalSession();
          if (res.success === 1) {
            this.toaster.success(res['message'] || 'Logged out successfully', 'LogOut');
          }
          // success:0 "User is not authenticated" still means local logout should complete
          this.router.navigate(['/login']);
        },
        err => {
          this.clearLocalSession();
          this.router.navigate(['/login']);
        },
      );
  }

  private clearLocalSession() {
    localStorage.removeItem('DarkCarz-merchant-data');
    localStorage.removeItem('DarkCarz-signup-user');
    localStorage.removeItem('token');
    localStorage.removeItem('driverProfile');
    localStorage.removeItem('reg-business-complete');
    sessionStorage.clear();
  }

  ngOnDestroy() {
    if (this.httpSub$) {
      this.httpSub$.unsubscribe();
    }
  }

}
